var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup__main",attrs:{"id":"popup-scan"}},[_c('div',{staticClass:"popup__header"},[_c('a',{staticClass:"popup__close",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.closePopup.apply(null, arguments)}}})]),_c('div',{staticClass:"popup__content"})])
}
var staticRenderFns = []

export { render, staticRenderFns }